import {CommonService} from "../services";
import {SongTypeService as Service} from "../services";

export default {
    namespaced: true,
    state: {
        stateItems: [],
        pagination: {
            page: 1,
            perPage: 10,
            totalPage: 0
        },
        search: '',
        loading: false,
        addEditDialog: false
    },
    mutations: {
        ADD_ITEM(state, item) {
            state.stateItems.push(item);
        },
        EDIT_ITEM(state, {itemToEdit, itemIndex}) {
            Object.assign(state.stateItems[itemIndex], itemToEdit);
        },
        SET_ALL_ITEMS(state, items) {
            state.pagination.totalPage = Math.ceil(items.count / state.pagination.perPage);
            state.stateItems.push(...items.results);
        },
        SET_PAGE(state, page) {
            state.pagination.page = page;
        },
        SET_TOTAL_PAGE(state, totalPage) {
            state.pagination.totalPage = totalPage;
        },
        SET_SEARCH(state, search) {
            state.search = search;
        },
        SHOW_ADD_EDIT_DIALOG(state, b) {
            state.addEditDialog = b;
        },
        CLEAR_ALL(state) {
            state.stateItems = [];
        },
    },
    actions: {
        requestAll({commit, state}) {
            if (state.stateItems.length !== 0) return;
            state.loading = true;
            Service.getAll(state.pagination, state.search).then((items) => {
                commit('SET_ALL_ITEMS', items);
            }).finally(() => {
                state.loading = false;
            })
        },
        setSearch({commit, dispatch}, search) {
            commit('SET_SEARCH', search);
            dispatch('setPage', 1);
        },
        setSave({dispatch, commit}, itemToSave) {
            dispatch('popupLoading', true);
            Service.add(itemToSave).then((item) => {
                itemToSave.parseItem = item;
                commit('ADD_ITEM', itemToSave)
            }).finally(() => {
                dispatch('popupLoading', false);
                dispatch('openAddEditDialog', false);
            });
        },
        setEdit({dispatch, commit}, {itemToEdit, itemIndex}) {
            dispatch('popupLoading', true);
            Service.edit(itemToEdit).then(() => {
                commit('EDIT_ITEM', {itemToEdit: itemToEdit, itemIndex: itemIndex});
            }).finally(() => {
                dispatch('popupLoading', false);
                dispatch('openAddEditDialog', false);
            });
        },
        setPage({dispatch, commit}, page) {
            commit('SET_PAGE', page);
            commit('CLEAR_ALL');
            dispatch('requestAll');
        },
        popupLoading(_, b) {
            CommonService.showLoading(b);
        },
        openAddEditDialog({commit}, b) {
            commit('SHOW_ADD_EDIT_DIALOG', b);
        },
    },
    getters: {
        getAll(state) {
            return state.stateItems;
        },
        getPagination(state) {
            return state.pagination;
        },
        getLoading(state) {
            return state.loading;
        },
        showAddEditDialog(state) {
            return state.addEditDialog
        }
    }
}